import { API_URL }  from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type':'application/json'
    }
});

class CentroDriveRequest {

    /**
     * Llamada el endpoint de django para obtener las configuraciones
     * que se agregaron para el centro suministrador que surtira al drive
     * en la BD
     * @param: nada
     * @return: Una lista de centro suministrador a drive.
     */
    static ListarCentroDrives(filtros) {
        return middleware.hasAuth(() => request.get(`api/centro/drive/`, {
            params: {
                filtro: filtros.filtro,
                page: filtros.page
            }
        }))
    }

    /**
     * Llamada el endpoint de django para configurar el centro suministrador del drive
     * @param: value. id de la notificación
     * @param: data. una lista de objetos que contiene datos de la notificación
     * @return: Mensaje de éxito o error.
     */
    static editarCentroSuministrador(value, data){
        if (value === null) {
            return middleware.hasAuth(() => request.post(`api/centro/drive/`, data));
        }
        else {
            return middleware.hasAuth(() => request.put(`api/centro/drive/?id=${value}`, data));
        }
    }

    static eliminarCentro(value){
        return middleware.hasAuth(() => request.delete(`api/centro/drive/delete/${value}/`));
    }
}
export default CentroDriveRequest;